<template>
  <div class="jd-navigator">
    <el-image class="ask-icon" :src="imgUrl" style="width:1000px"></el-image>
    <img src="../../assets/images/立即订购arrow.svg" alt class="arrowBtn" @click="jtjunk()">
    <img src="../../assets/images/立即订购BTN.svg" alt class="buyBtn1" @click="jtjunk()">
    <img src="../../assets/images/立即订购BTN.svg" alt class="buyBtn2" @click="jtjunk()">
    <img src="../../assets/images/立即订购BTN.svg" alt class="buyBtn3" @click="jtjunk()">
  </div>
</template>

<script>
import functionCompare from "./function-compare";
export default {
  name: "jdNavigator",
  components: {
    functionCompare
  },
  data() {
    return {
      imgUrl: require("@/assets/images/double222.png"),
      show1: true
    };
  },
  mounted(){
    // 页面埋点
    this.buriedPoint(1, "引导订购京获客页面", "行业专区", "引导订购京获客页面");
  },
  methods: {
    jtjunk() {
      this.buriedPoint(2,'京获客落地页/订购');
      const href = "https://fw.jd.com/main/detail/FW_GOODS-1415006";
      window.open(href, "_blank");
    }
  }
};
</script>

<style lang='scss' scoped>
.jd-navigator {
  margin: 0 auto;
  width: 1000px;
  position: relative;
  .arrowBtn {
    position: absolute;
    top: 16px;
    right: 227px;
    cursor: pointer;
  }
  .buyBtn1 {
    position: absolute;
    cursor: pointer;
    width: 220px;
    height: 60px;
    top: 37.8%;
    left: 40%;
  }
  .buyBtn2 {
    position: absolute;
    cursor: pointer;
    width: 220px;
    height: 60px;
    top: 65.9%;
    left: 40%;
  }
  .buyBtn3 {
    position: absolute;
    cursor: pointer;
    width: 220px;
    height: 60px;
    top: 98%;
    left: 40%;
  }
}
</style>
